export const PLANTIO_ACTIONS_TYPES = {
	SET_PLANTIO: "plantio/SET_PLANTIO",
	SET_APP: "plantio/SET_APP",
	SET_APP_FARMBOX: "plantio/SET_APP_FARMBOX",
	SET_SAFRA_CICLO: "plantio/SET_SAFRA_CICLO",
	SET_PLANTIO_MAP_ALL: "plantio/SET_PLANTIO_MAP_ALL",
	SET_PLUVI: "plantio/SET_PLUVI",
	SET_CALENDAR_DONE: "plantio/SET_CALENDAR_DONE",
	SET_PLANTIO_COLHEITA_ATUAL: "plantio/SET_PLANTIO_COLHEITA_ATUAL",
	SET_COLHEITA_PORTAL_DATA: "plantio/SET_COLHEITA_PORTAL_DATA",
	SET_USE_MULTI: "plantio/SET_USE_MULTI",

};
